import Login from "@/pages/Login.vue";
import Logout from "@/pages/Logout.vue";
import Callback from "@/pages/Callback.vue";
import Terms from "@/pages/Terms.vue";
import Nda from "@/pages/Nda.vue";
import InvitationLogin from "@/pages/InvitationLogin.vue";

export default [
  {
    name: "login",
    path: "/login",
    component: Login
  },
  {
    name: "invitation-login",
    path: "/ehPipelineSubs/login/enc/:projectId/cne/:companyId/c/:securityCode",
    component: InvitationLogin,
  },
  {
    name: "invitation-response",
    path: "/ehPipelineSubs/login/enc/:projectId/cne/:companyId/c/:securityCode/r/:emailResponse(1|2|3)",
    component: InvitationLogin,
  },
  {
    name: "logout",
    path: "/logout",
    component: Logout
  },
  {
    name: "callback",
    path: "/callback",
    component: Callback,
  },
  {
    name: "terms",
    path: "/terms",
    component: Terms,
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: "nda",
    path: "/nda",
    component: Nda,
    meta: {
      requiresAuth: true,
    },
  }
]
